export enum EActions {
    all = "all",
    read = "read",
    create = "create",
    update = "update",
    delete = "delete"
}

export enum EAggregationType {
    terms = "terms",
    sum = "sum",
    min_max = "min_max",
    nested = "nested"
}

export enum EAllTenantRights {
    allow = "allow",
    deny = "deny"
}

export enum EEmitterEvents {
    beforeRead = "beforeRead",
    afterRead = "afterRead",
    beforeSearch = "beforeSearch",
    afterSearch = "afterSearch",
    beforeCreate = "beforeCreate",
    afterCreate = "afterCreate",
    beforeUpdate = "beforeUpdate",
    afterUpdate = "afterUpdate",
    beforeRemove = "beforeRemove",
    afterRemove = "afterRemove",
    beforeRegister = "beforeRegister",
    afterRegister = "afterRegister",
    beforeLogin = "beforeLogin",
    afterLogin = "afterLogin",
    beforeLogout = "beforeLogout",
    afterLogout = "afterLogout",
    afterBodyBuild = "afterBodyBuild",
    afterImpersonate = "afterImpersonate",
    afterReadError = "afterReadError",
    beforeUpload = "beforeUpload",
    afterUpload = "afterUpload"
}

export enum EFormEvent {
    beforeInit = "beforeInit",
    init = "init",
    afterInit = "afterInit",
    fieldChange = "fieldChange",
    beforeValidate = "beforeValidate",
    afterValidate = "afterValidate",
    beforeTransform = "beforeTransform",
    afterTransform = "afterTransform",
    afterCheckChanges = "afterCheckChanges",
    tabChange = "tabChange",
    beforeSubmit = "beforeSubmit",
    afterSubmit = "afterSubmit",
    beforeSearch = "beforeSearch",
    afterSearch = "afterSearch",
    select = "select",
    change = "change",
    clear = "clear",
    upload = "upload",
    titleChange = "titleChange",
    focus = "focus",
    blur = "blur",
    updateFormValue = "updateFormValue",
    tabSettingsChange = "tabSettingsChange",
    setActiveTab = "setActiveTab",
    setItem = "setItem",
    setFocus = "setFocus",
    beforeCreateNew = "beforeCreateNew",
    afterCreateNew = "afterCreateNew",
    tabSettings = "tabSettings"
}

export enum EFormFieldType {
    hidden = "hidden",
    string = "string",
    stringLocale = "stringLocale",
    array = "array",
    text = "text",
    textLocale = "textLocale",
    number = "number",
    search = "search",
    select = "select",
    image = "image",
    boolean = "boolean",
    date = "date",
    dateRange = "dateRange",
    workTime = "workTime",
    file = "file",
    passwordGenerator = "passwordGenerator",
    tree = "tree",
    color = "color",
    delimiter = "delimiter",
    grid = "grid",
    gridPopup = "gridPopup",
    table = "table",
    object = "object",
    numberVisualization = "numberVisualization",
    currency = "currency",
    customFields = "customFields",
    rate = "rate",
    timer = "timer",
    durationParser = "durationParser",
    textMention = "textMention",
    calendarMeeting = "calendarMeeting",
    countrySpecific = "countrySpecific"
}

export enum EFormMode {
    edit = "edit",
    create = "create"
}

export enum EFormValidator {
    number = "number",
    email = "email",
    float = "float",
    floatNoZero = "floatNoZero",
    phone = "phone",
    password = "password",
    name = "name",
    uniqDb = "uniqDb",
    web = "web",
    bulstat = "bulstat",
    iban = "iban",
    bic = "bic",
    egn = "egn"
}

export enum EGridCustomField {
    boolean = "boolean",
    string = "string",
    text = "text",
    number = "number",
    search = "search",
    select = "select",
    date = "date",
    dateRange = "dateRange",
    currency = "currency",
    email = "email",
    web = "web",
    object = "object",
    array = "array"
}

export enum EGridEvent {
    actionInit = "actionInit",
    actionReInit = "actionReInit",
    actionClick = "actionClick",
    init = "init",
    beforeRead = "beforeRead",
    afterRead = "afterRead",
    beforeUpdate = "beforeUpdate",
    afterUpdate = "afterUpdate",
    beforeCreate = "beforeCreate",
    afterCreate = "afterCreate",
    beforeRemove = "beforeRemove",
    afterRemove = "afterRemove",
    beforeRender = "beforeRender",
    rowSelected = "rowSelected",
    change = "change",
    cancel = "cancel",
    beforeItemsUpdate = "beforeItemsUpdate",
    afterItemsUpdate = "afterItemsUpdate",
    itemsChange = "itemsChange",
    setCreateMode = "setCreateMode",
    setEditMode = "setEditMode",
    setPlugin = "setPlugin",
    removeItem = "removeItem",
    searchSettingsChange = "searchSettingsChange"
}

export enum EGridFieldType {
    avatar = "avatar",
    link = "link",
    linkHighlight = "linkHighlight",
    highlight = "highlight",
    string = "string",
    address = "address",
    array = "array",
    date = "date",
    boolean = "boolean",
    currency = "currency",
    number = "number",
    tag = "tag",
    image = "image",
    valueMap = "valueMap",
    workTime = "workTime",
    characteristicGroupItems = "characteristicGroupItems",
    fileSize = "fileSize",
    relatedTo = "relatedTo",
    repeats = "repeats",
    dateRange = "dateRange",
    countrySpecificData = "countrySpecificData",
    object = "object",
    customField = "customField"
}

export enum EGridSorting {
    ascend = "ascend",
    descend = "descend"
}

export enum EHistoryAction {
    read = "read",
    search = "search",
    create = "create",
    update = "update",
    remove = "remove",
    login = "login",
    upload = "upload",
    download = "download"
}

export enum EPluginPosition {
    left = "left",
    right = "right"
}

export enum ERightsType {
    entityPermission = "entityPermission",
    businessPermission = "businessPermission"
}

export enum ESearchFilterType {
    _text = "_text",
    _range = "_range",
    _rangeE = "_rangeE",
    _rangeDate = "_rangeDate",
    _not = "_not",
    _exists = "_exists",
    _not_exists = "_not_exists",
    _and = "_and",
    _or = "_or",
    _json = "_json",
    _exact = "_exact",
    _collapse = "_collapse",
    _db_rule = "_db_rule",
    _nested = "_nested",
    _vector = "_vector",
    _regex = "_regex",
    _customField = "_customField"
}

export enum ESecurityGroupRights {
    all = "all",
    read = "read",
    create = "create",
    update = "update",
    remove = "remove",
    denied = "denied"
}

export enum ESimpleGridCustomField {
    boolean = "boolean",
    string = "string",
    text = "text",
    number = "number",
    search = "search",
    select = "select",
    date = "date",
    dateRange = "dateRange",
    currency = "currency",
    email = "email",
    web = "web"
}

export enum ETabEvent {
    init = "init",
    tabInit = "tabInit",
    afterRead = "afterRead"
}

export enum ETextAlign {
    left = "left",
    right = "right",
    center = "center"
}

export enum ETimePeriod {
    day = "day",
    week = "week",
    month = "month"
}

export enum EUserRights {
    all = "all",
    read = "read",
    create = "create",
    update = "update",
    remove = "remove",
    denied = "denied"
}

export enum EAddressType {
    work = "work",
    home = "home",
    billing = "billing",
    other = "other"
}

export enum EAiPromptType {
    "Extract Timeline Data" = "Extract Timeline Data",
    "Evaluate Image Quality and Content" = "Evaluate Image Quality and Content",
    "Match Invoice to Contracts" = "Match Invoice to Contracts",
    "Group Annexes" = "Group Annexes",
    "Find Related Contract for Annex" = "Find Related Contract for Annex",
    "Extract Structured Data from Annex" = "Extract Structured Data from Annex",
    "Extract Invoice Structured Data" = "Extract Invoice Structured Data",
    "Convert Invoice Images to Markdown" = "Convert Invoice Images to Markdown",
    "Extract Contract Structured Data" = "Extract Contract Structured Data",
    "Find Document Relationships" = "Find Document Relationships",
    "Convert Image to Markdown (Gemini)" = "Convert Image to Markdown (Gemini)",
    "Classify Document" = "Classify Document",
    "Extract New Contract Type" = "Extract New Contract Type"
}

export enum EAiProvider {
    gemini = "gemini",
    anthropic = "anthropic"
}

export enum EAiProviderModel {
    "gemini-2.0-flash" = "gemini-2.0-flash",
    "gemini-2.5-flash" = "gemini-2.5-flash",
    "gemini-2.5-pro" = "gemini-2.5-pro",
    "claude-3-7-sonnet-latest" = "claude-3-7-sonnet-latest"
}

export enum EAlertPriority {
    low = "low",
    normal = "normal",
    high = "high",
    extreme = "extreme"
}

export enum EAlertType {
    contractExpiration = "contractExpiration",
    qualityControl = "qualityControl"
}

export enum EBusinessObjectAreaDimension {
    sq_m = "sq_m"
}

export enum EBusinessObjectType {
    building = "building",
    apartment = "apartment",
    commercialPremises = "commercialPremises",
    undergroundParkingSpace = "undergroundParkingSpace",
    garage = "garage",
    office = "office",
    roomForSleeping = "roomForSleeping",
    parkingLot = "parkingLot",
    house = "house",
    logisticsPark = "logisticsPark",
    administrativeBuildingAndOffice = "administrativeBuildingAndOffice",
    administrativeBuildingAndArchive = "administrativeBuildingAndArchive",
    land = "land",
    courierServicesOffice = "courierServicesOffice",
    logisticsCenter = "logisticsCenter",
    administrativeBuilding = "administrativeBuilding",
    academy = "academy",
    houseForOvernightStaysForBusinessTravelers = "houseForOvernightStaysForBusinessTravelers",
    unspecified = "unspecified"
}

export enum EContractDocumentType {
    contract = "contract",
    agreement = "agreement",
    order = "order",
    offer = "offer"
}

export enum EContractNumberPrefix {
    empty = "empty",
    dateYM = "dateYM",
    dateY = "dateY",
    name = "name"
}

export enum EContractNumberSuffix {
    empty = "empty",
    name = "name"
}

export enum EContractPeriodType {
    fixedTerm = "fixedTerm",
    IndefiniteTerm = "IndefiniteTerm",
    untilCompletionWork = "untilCompletionWork",
    autoRenewal = "autoRenewal",
    trailPeriod = "trailPeriod"
}

export enum EContractSubject {
    framework = "framework",
    lease = "lease",
    construction = "construction",
    preliminary_feasibility_study = "preliminary_feasibility_study",
    design = "design",
    author_supervision = "author_supervision",
    construction_supervision = "construction_supervision",
    legal_consultations = "legal_consultations",
    service_and_maintenance = "service_and_maintenance",
    crw = "crw",
    crw_in_building = "crw_in_building",
    crw_on_inventory = "crw_on_inventory",
    cleaning = "cleaning",
    facility_management = "facility_management",
    snow_removal = "snow_removal",
    landscaping = "landscaping",
    waste_disposal = "waste_disposal",
    subscription_cleaning = "subscription_cleaning",
    pest_control = "pest_control",
    access_control = "access_control",
    video_surveillance = "video_surveillance",
    security_and_alarm = "security_and_alarm",
    representative_expenses = "representative_expenses",
    other = "other",
    utility = "utility",
    electricity = "electricity",
    water_supply = "water_supply",
    district_heating = "district_heating",
    employment = "employment",
    procurement = "procurement",
    licensing = "licensing",
    partnership = "partnership",
    joint_venture = "joint_venture",
    financial = "financial",
    loan = "loan",
    mortgage = "mortgage",
    leaseback = "leaseback",
    nda = "nda",
    confidentiality = "confidentiality",
    sales = "sales",
    marketing = "marketing",
    sponsorship = "sponsorship",
    advertising = "advertising",
    it_maintenance = "it_maintenance",
    technical_support = "technical_support",
    research = "research",
    development = "development",
    ip_assignment = "ip_assignment",
    ip_transfer = "ip_transfer",
    sla = "sla",
    logistics = "logistics",
    transportation = "transportation",
    insurance = "insurance",
    government = "government",
    public_private_partnership = "public_private_partnership",
    training = "training",
    education = "education"
}

export enum ECustomFieldRelatedIndex {
    characteristic = "characteristic",
    contract = "contract",
    businessObject = "businessObject",
    party = "party"
}

export enum EDraftType {
    contract = "contract",
    invoice = "invoice",
    annex = "annex",
    payment_statement = "payment_statement"
}

export enum EFileLinkType {
    file = "file",
    web = "web",
    image = "image",
    phone = "phone",
    email = "email"
}

export enum EFileType {
    file = "file",
    directory = "directory"
}

export enum EFilesAndFoldersCategory {
    annex = "annex",
    contract = "contract",
    schedule = "schedule",
    invoice = "invoice",
    receipt = "receipt",
    payment_order = "payment_order",
    bank_statement = "bank_statement",
    debit_note = "debit_note",
    credit_note = "credit_note",
    construction_permit = "construction_permit",
    property_deed = "property_deed",
    personal_identification = "personal_identification",
    disability_certificate = "disability_certificate",
    business_license = "business_license",
    tax_certificate = "tax_certificate",
    insurance_certificate = "insurance_certificate",
    regulatory_approval = "regulatory_approval",
    notice = "notice",
    termination_notice = "termination_notice",
    termination_agreement = "termination_agreement",
    demand_letter = "demand_letter",
    dispute_resolution_document = "dispute_resolution_document",
    handover_protocol = "handover_protocol",
    maintenance_report = "maintenance_report",
    utility_bill = "utility_bill",
    proforma_invoice = "proforma_invoice",
    inventory_list = "inventory_list",
    work_order = "work_order",
    service_report = "service_report",
    completion_certificate = "completion_certificate",
    inspection_report = "inspection_report",
    progress_report = "progress_report",
    audit_report = "audit_report",
    guarantee_certificate = "guarantee_certificate",
    memorandum_of_understanding = "memorandum_of_understanding",
    letter_of_intent = "letter_of_intent",
    non_disclosure_agreement = "non_disclosure_agreement",
    power_of_attorney = "power_of_attorney",
    security_deposit_agreement = "security_deposit_agreement",
    employment_agreement = "employment_agreement",
    invoice_protocol = "invoice_protocol",
    invoice_description = "invoice_description",
    original = "original",
    other = "other",
    property_handover_protocol = "property_handover_protocol",
    invoice_acceptance_protocol = "invoice_acceptance_protocol",
    work_completion_handover_protocol = "work_completion_handover_protocol",
    settlement_agreement = "settlement_agreement",
    blank_pages = "blank_pages",
    mortgage_deed = "mortgage_deed",
    cadastral_plan = "cadastral_plan",
    payment_statement = "payment_statement",
    approval_request = "approval_request",
    approval_acknowledgment = "approval_acknowledgment"
}

export enum EFilesAndFoldersMode {
    draft = "draft",
    normal = "normal"
}

export enum EFormatDate {
    "MM/DD/YYYY" = "MM/DD/YYYY",
    "DD/MM/YYYY" = "DD/MM/YYYY",
    "DD-MM-YYYY" = "DD-MM-YYYY",
    "YYYY-MM-DD" = "YYYY-MM-DD",
    "DD.MM.YYYY" = "DD.MM.YYYY",
    "YY/MM/DD" = "YY/MM/DD"
}

export enum EFormatNumber {
    "$x,xxx.xx" = "$x,xxx.xx",
    "x,xxx.xx $" = "x,xxx.xx $",
    "x xxx,xx $" = "x xxx,xx $",
    "$x'xxx.xx" = "$x'xxx.xx"
}

export enum EFormatTime {
    "hh:mm A" = "hh:mm A",
    "hh:mm a" = "hh:mm a",
    "HH:mm" = "HH:mm"
}

export enum EInvoiceItemStatus {
    draft = "draft",
    pendingApproval = "pendingApproval",
    notInvoiced = "notInvoiced",
    partiallyInvoiced = "partiallyInvoiced",
    invoiced = "invoiced"
}

export enum EInvoiceStatus {
    draft = "draft",
    pendingApproval = "pendingApproval",
    unpaid = "unpaid",
    partiallyPayed = "partiallyPayed",
    canceled = "canceled",
    reversal = "reversal",
    payed = "payed"
}

export enum ELogEnvironment {
    server = "server",
    jira = "jira"
}

export enum ELogSeverity {
    info = "info",
    warn = "warn",
    error = "error"
}

export enum EPartyType {
    company = "company",
    person = "person"
}

export enum EQualityControlPeriod {
    weekly = "weekly",
    monthly = "monthly",
    yearly = "yearly",
    afterJobComplete = "afterJobComplete"
}

export enum EResearchAnnotationType {
    highlight = "highlight",
    freeDraw = "freeDraw",
    textNote = "textNote",
    relation = "relation"
}

export enum ESearchStrategy {
    exact = "exact",
    edgeNgram = "edgeNgram",
    ngram = "ngram"
}

export enum ESyncStatus {
    idle = "idle",
    inProgress = "inProgress",
    error = "error"
}

export enum ESyncType {
    googleCalendar = "googleCalendar",
    microsoftCalendar = "microsoftCalendar",
    googleEmail = "googleEmail",
    microsoftEmail = "microsoftEmail",
    zoomMeeting = "zoomMeeting",
    googleMeeting = "googleMeeting",
    microsoftMeeting = "microsoftMeeting",
    jira = "jira"
}

export enum ESyncWarning {
    noCloudRecording = "noCloudRecording"
}

export enum ESystemDirectoryType {
    communication = "communication",
    meeting = "meeting",
    unknown = "unknown",
    other = "other",
    hidden = "hidden",
    original = "original"
}

export enum ECustomFieldAllowIndex {
    contract = "contract",
    party = "party"
}

export enum ECurrency {
    eur = "eur",
    bgn = "bgn"
}

export enum ELanguages {
    en = "en",
    bg = "bg"
}

export enum EMailingType {
    mailClient = "mailClient",
    sendgrid = "sendgrid"
}

export enum EInvoiceActionType {
    sent = "sent",
    delivered = "delivered"
}

export enum EInvoiceCreditType {
    money = "money"
}

export enum EInvoiceDeliveryStatus {
    notSent = "notSent",
    sent = "sent",
    delivered = "delivered"
}

export enum EInvoiceDiscountType {
    percent = "percent",
    fixed = "fixed"
}

export enum EInvoiceGenerationMethod {
    auto = "auto",
    manual = "manual"
}

export enum EInvoiceNoteType {
    value = "value",
    quantity = "quantity"
}

export enum EInvoicePaymentMethod {
    bank = "bank",
    cash = "cash"
}

export enum EInvoicePaymentStatus {
    unpaid = "unpaid",
    partiallyPayed = "partiallyPayed",
    payed = "payed"
}

export enum EInvoicePeriod {
    month = "month",
    halfMonth = "halfMonth",
    everyAction = "everyAction"
}

export enum EInvoiceType {
    invoice = "invoice",
    advancePayment = "advancePayment",
    creditNote = "creditNote",
    debitNote = "debitNote",
    reversalProtocol = "reversalProtocol"
}

export enum EProtocolInvoiceType {
    oldDocument = "oldDocument",
    newDocument = "newDocument"
}

export enum EVatType {
    percent = "percent"
}

export enum EIndex {
    file = "file",
    gridDecorator = "gridDecorator",
    health = "health",
    image = "image",
    notification = "notification",
    recycleBin = "recycleBin",
    report = "report",
    securityGroup = "securityGroup",
    taskManagement = "taskManagement",
    template = "template",
    user = "user",
    versionManaged = "versionManaged",
    aiPrompt = "aiPrompt",
    alert = "alert",
    area = "area",
    businessObject = "businessObject",
    characteristic = "characteristic",
    city = "city",
    company = "company",
    contract = "contract",
    contractNumber = "contractNumber",
    contractTemplate = "contractTemplate",
    country = "country",
    deduplication = "deduplication",
    draft = "draft",
    exchangeRates = "exchangeRates",
    filesAndFolders = "filesAndFolders",
    gridCustomField = "gridCustomField",
    jira = "jira",
    log = "log",
    party = "party",
    qualityControlRule = "qualityControlRule",
    qualityControlScore = "qualityControlScore",
    sync = "sync",
    timeline = "timeline",
    vatCountry = "vatCountry",
    db_version = "db_version",
    globalSearch = "globalSearch",
    invoice = "invoice",
    invoiceNumber = "invoiceNumber",
    invoiceProtocol = "invoiceProtocol",
    invoiceRule = "invoiceRule"
}

export enum EReports {
    unpaidInvoices = "unpaidInvoices",
    overdueInvoices = "overdueInvoices",
    draftInvoices = "draftInvoices",
    invoiceCollection = "invoiceCollection",
    businessObjectExpensesBySubject = "businessObjectExpensesBySubject",
    businessObjectExpensesByContract = "businessObjectExpensesByContract",
    contractExpensesByBusinessObject = "contractExpensesByBusinessObject",
    collectInvoiceContractSubjects = "collectInvoiceContractSubjects",
    collectInvoiceBusinessObjects = "collectInvoiceBusinessObjects",
    contractExpensesBySubject = "contractExpensesBySubject",
    businessObjectExpenses = "businessObjectExpenses",
    contractExpenses = "contractExpenses",
    contractSubjectExpenses = "contractSubjectExpenses",
    partyExpenses = "partyExpenses",
    contractSubjectExpenseByBusinessObject = "contractSubjectExpenseByBusinessObject",
    contractSubjectExpense = "contractSubjectExpense",
    businessObjectExpenseAll = "businessObjectExpenseAll",
    partyExpenseAll = "partyExpenseAll"
}

export enum EIndices {
    file = "file",
    gridDecorator = "gridDecorator",
    health = "health",
    image = "image",
    notification = "notification",
    recycleBin = "recycleBin",
    report = "report",
    securityGroup = "securityGroup",
    taskManagement = "taskManagement",
    template = "template",
    user = "user",
    versionManaged = "versionManaged",
    aiPrompt = "aiPrompt",
    alert = "alert",
    area = "area",
    businessObject = "businessObject",
    characteristic = "characteristic",
    city = "city",
    company = "company",
    contract = "contract",
    contractNumber = "contractNumber",
    contractTemplate = "contractTemplate",
    country = "country",
    deduplication = "deduplication",
    draft = "draft",
    exchangeRates = "exchangeRates",
    filesAndFolders = "filesAndFolders",
    gridCustomField = "gridCustomField",
    jira = "jira",
    log = "log",
    party = "party",
    qualityControlRule = "qualityControlRule",
    qualityControlScore = "qualityControlScore",
    sync = "sync",
    timeline = "timeline",
    vatCountry = "vatCountry",
    db_version = "db_version",
    globalSearch = "globalSearch",
    invoice = "invoice",
    invoiceNumber = "invoiceNumber",
    invoiceProtocol = "invoiceProtocol",
    invoiceRule = "invoiceRule"
}

export enum EErrors {
    accessDenied = -1,
    badRequest = -2,
    itemNotFound = -3,
    databaseError = -4,
    invalidToken = -5,
    eventNotFound = -6,
    userExists = -7,
    userNotFound = -8,
    itemWithRelation = -9,
    duplicatedField = -10,
    dbError = -11,
    suspendedUser = -12,
    readTemplateResultError = -13,
    smsNotSend = -14,
    missingRequiredField = -15,
    itemAlreadyExists = -16,
    accessCodeAlreadyUsed = -17,
    accessLinkAlreadyUsed = -18,
    accessCodeAlreadySent = -19,
    tooManyAttempts = -20,
    invalidLoginIndex = -21,
    communicationChanelNotFound = -22,
    notInitialized = -23,
    emailTemplateNameNotFound = -24,
    emailTemplateCountryNotFound = -25,
    templateFileGeneratorError = -26,
    mailNotSend = -27,
    companyWithoutEmail = -28,
    contractProcessorError = -29,
    invoiceProcessorError = -30,
    fieldValidationError = -31,
    possiblePartyDuplication = -32,
    possibleBusinessObjectDuplication = -33,
    incompleteAddress = -34,
    contractAlreadyExists = -35,
    annexAlreadyExists = -36,
    handwrittenPages = -37,
    missingRelatedContract = -38,
    missingBusinessObject = -39,
    contractPeriodNotDefined = -40,
    invalidContractData = -41,
    invalidInvoiceData = -42,
    missingFromParty = -43,
    missingToParty = -44,
    missingContractType = -45,
    missingContract = -46,
    invoiceAlreadyExists = -47,
    documentIsNotAnnex = -48,
    documentIsNotInvoice = -49,
    invalidInvoiceCalculation = -50,
    partyWithoutIdentifier = -51,
    wrongPartyIdentifier = -52,
    wrongInvoiceTotalValue = -53,
    invoiceRowWithoutContract = -54,
    invoiceRowWithoutBusinessObject = -55,
    invoiceRowWithoutContractSubject = -56,
    fileAlreadyExists = -57,
    documentAlreadyExists = -58,
    processTimeout = -59,
    manyRelatedDocuments = -60,
    invoiceRowWithoutPeriod = -61,
    missingContractObject = -62,
    invoiceRowAlreadyExists = -63,
    unsupportedFileType = -64,
    verySmallFile = -65,
    invoiceWithoutItems = -66,
    sameUploadFiles = -67
}
